import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { ExpansionResult } from "slotworks/model/gameplay/records/results/expansion-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";
import Sequence from "slotworks/utils/contracts/sequence";

export default class ExpandSymbols extends State {

    protected sequence: boolean;

    protected isComplete: boolean;
    protected skipped: boolean;

    protected sourceSymbolId: string;

    public onEnter() {
        this.isComplete = false;
        this.skipped = false;

        const spinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        const expansions: ExpansionResult[] = spinRecord.getResultsOfType(ExpansionResult);

        const expands: Array<(() => Contract<any>)> = [];

        for (const expansion of expansions) {
            expands.push(
                () => new Sequence([
                    () => this.expand(expansion),
                    () => this.singleExpandComplete(expansion)
                ]
            ));
        }

        if (this.sequence) {
            new Sequence(expands).then(() => this.expandsComplete());
        } else {
            new Parallel(expands).then(() => this.expandsComplete());
        }
    }

    public onSkip() {
        this.skipped = true;
        Services.sound.event(SoundEvent.skip_expands);
        this.expandsComplete();
    }

    protected expand(expansion: ExpansionResult): Contract<void> {
        if (this.skipped) {
            return Contract.empty();
        }

        const sourceSymbol = Components.matrix.getSymbol(expansion.source.x, expansion.source.y);
        const targetSymbol = Components.matrix.getSymbol(expansion.target.x, expansion.target.y);

        this.sourceSymbolId = sourceSymbol.symbolId;

        const directionX = targetSymbol.gridPosition.x - sourceSymbol.gridPosition.x;
        const directionY = targetSymbol.gridPosition.y - (sourceSymbol.gridPosition.y - sourceSymbol.getStackOffset());

        return sourceSymbol.expand(directionX, directionY);
    }

    protected singleExpandComplete(expansion: ExpansionResult): Contract<void> {
        return Contract.empty();
    }

    protected expandsComplete() {
        if (!this.isComplete) {
            this.isComplete = true;

            const spinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
            const expansions: ExpansionResult[] = spinRecord.getResultsOfType(ExpansionResult);

            for (const expansion of expansions) {

                const sourceSymbolId = expansion.sourceSymbolID;
                let targetSymbolId: string;
                if (expansion.targetSymbolID) {
                    targetSymbolId = expansion.targetSymbolID;
                } else {
                    targetSymbolId = sourceSymbolId + "_expanded";
                }

                const sourceSymbol = Components.matrix.getSymbol(expansion.source.x, expansion.source.y);
                sourceSymbol.static();
                sourceSymbol.setSymbol(targetSymbolId);

                for (const position of expansion.expansions) {
                    const symbol = Components.matrix.getSymbol(position.x, position.y);
                    symbol.static();
                    symbol.setSymbol(targetSymbolId);
                }
            }
            this.complete();
        }
    }
}
